import React from "react";
import { Icon } from "./Icon";

interface Info32Props {
  size?: number;
  className?: string;
  color?: string;
}

export const Info32: React.FC<Info32Props> = ({ size, className, color }) => {
  return (
    <Icon size={size} className={className} color={color}>
      <path d="M585.6 633.6h-25.6c-9.6 0-19.2-6.4-19.2-19.2v-131.2c0-32-25.6-57.6-57.6-57.6h-25.6c-19.2 0-32 12.8-32 32s12.8 32 32 32h22.4v128c0 44.8 35.2 83.2 83.2 83.2h25.6c19.2 0 28.8-16 28.8-35.2s-12.8-32-32-32z" />
      <path d="M499.2 384c22.4 0 44.8-19.2 44.8-44.8s-19.2-44.8-44.8-44.8-44.8 19.2-44.8 44.8 19.2 44.8 44.8 44.8z" />
      <path d="M512 83.2c-236.8 0-428.8 195.2-428.8 428.8s192 425.6 428.8 425.6c233.6 0 428.8-188.8 428.8-425.6s-192-428.8-428.8-428.8zM512 876.8c-201.6 0-364.8-163.2-364.8-364.8s163.2-364.8 364.8-364.8c198.4 0 364.8 163.2 364.8 364.8s-163.2 364.8-364.8 364.8z" />
    </Icon>
  );
};
